import { render, staticRenderFns } from "./interactive-sidebar-item.vue?vue&type=template&id=7fca8395&scoped=true&"
import script from "./interactive-sidebar-item.vue?vue&type=script&lang=js&"
export * from "./interactive-sidebar-item.vue?vue&type=script&lang=js&"
import style0 from "./interactive-sidebar-item.vue?vue&type=style&index=0&id=7fca8395&scoped=true&lang=scss&"
import style1 from "./interactive-sidebar-item.vue?vue&type=style&index=1&id=7fca8395&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fca8395",
  null
  
)

export default component.exports